<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}" :width="$vuetify.breakpoint.lgAndUp ? 1134 : 'auto'">
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('accept_request')" aria-hidden="true" translate="no">close</v-icon>
            <template v-if="request_type=='Сотрудник'">
                <v-card-title class="display-1 mb-4">{{ $t("Одобрить нового пользователя") }}</v-card-title>
                <v-layout mb-4 wrap align-center>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Фамилия") }} *</div>
                        <inputBase :placeholder="$t('Введите фамилию')" disabled :value="current_request.surname || current_request.last_name" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Имя") }} *</div>
                        <inputBase :placeholder="$t('Введите имя')" disabled :value="current_request.name" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.sm}"
                    >
                        <div class="grey-text mb-2">{{ $t("Отчество") }} *</div>
                        <inputBase :placeholder="$t('Введите отчество')" disabled :value="current_request.patronymic || current_request.middle_name" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">E-mail *</div>
                        <inputBase :placeholder="$t('Введите e-mail')" disabled :value="current_request ? current_request.email : ''" />
                    </v-flex>
                    <v-flex md8 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.sm, 'pr-0': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Должность") }} *</div>
                        <inputBase :placeholder="$t('Введите должность')" disabled :value="current_request ? current_request.position : ''" />
                    </v-flex>
                    <!-- <v-flex md4 sm6 xs12
                            mb-0 :class="{'mb-4': $vuetify.breakpoint.xs}"
                    >
                        <checkbox v-if="!current_request.external" id="internal" :checked="true"
                                  disabled
                        >{{ $t("Внутренний пользователь") }}</checkbox>
                    </v-flex> -->
                    <v-flex v-if="current_request && !current_request.external" md4 sm6
                            xs12 mb-4 :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Управление") }} *</div>
                        <inputBase :value="current_request ? current_request.department : ''" disabled />
                    </v-flex>
                    <v-flex v-if="current_request && current_request.external" md4 sm6
                            xs12 mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Организация") }} *</div>
                        <inputBase :value="current_request ? current_request.organization : ''" disabled />
                    </v-flex>
                    <!-- <v-flex v-if="current_request && current_request.external" md4 sm6
                            xs12 mb-4 :class="{'pr-4': $vuetify.breakpoint.sm, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Специализация") }} *</div>
                        <inputBase :value="current_request ? current_request.specialization : ''" disabled />
                    </v-flex> -->
                    <v-flex md8 sm12 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp && current_request && current_request.department!='', }"
                    >
                        <div class="grey-text mb-2">{{ $t("Роль") }} *</div>
                        <inputBase :value="current_request ? current_request.role : ''" disabled />
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-layout align-center wrap>
                        <buttonRed :class="{'flex xs12 mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="acceptNewUser">{{ $t("Одобрить") }}</buttonRed>
                        <buttonBdWhite :class="{'flex xs12 mt-3': $vuetify.breakpoint.xs}" @click.native="declineNewUser">{{ $t("Отклонить") }}</buttonBdWhite>
                        <div class="grey-text" :class="{'ml-4': $vuetify.breakpoint.smAndUp, 'mt-2': $vuetify.breakpoint.xs}">{{ $t("* - поля, обязательные для заполнения") }}</div>
                    </v-layout>
                </v-card-actions>
            </template>

            <template v-else>
                <v-card-title class="display-1 mb-4">{{ $t("Одобрить новую организацию") }}</v-card-title>
                <v-layout mb-4 wrap align-center
                          justify-space-between
                >
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Название") }} *</div>
                        <inputBase :placeholder="$t('Введите название')" :value="current_request.name" disabled />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Регион") }} *</div>
                        <inputBase :placeholder="$t('Введите регион')" :value="current_request.region" disabled />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.sm}"
                    >
                        <div class="grey-text mb-2">{{ $t("Город") }} *</div>
                        <inputBase :placeholder="$t('Введите город')" :value="current_request.city" disabled />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Номер телефона") }}</div>
                        <inputBase :placeholder="$t('Введите номер')" :value="current_request.phone" disabled />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">E-mail *</div>
                        <inputBase :placeholder="$t('Введите e-mail')" :value="current_request.email" disabled />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4
                    >
                        <div class="grey-text mb-2">{{ $t("Адрес") }} *</div>
                        <inputBase :placeholder="$t('Введите адрес')" :value="current_request.address" disabled />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}" class="wrapper-relative"
                    >
                        <div class="grey-text mb-2">{{ $t("Логотип") }}</div>
                        <inputUpload id="logo_upload" :placeholder="$t('Загрузить логотип...')" :files="current_request.logo"
                                     disabled
                        />
                        <div class="grey-text" style="position: absolute;">{{ $t("Файлы в формате jpg., png. не более 64 КБ") }} </div>
                    </v-flex>

                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'mt-4': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Управление") }}</div>
                        <v-select
                            solo
                            append-icon=""
                            :label="$t('Выберите отдел')"
                            class="input"
                            disabled
                            :value="current_request.group"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'pr-4 mt-4': $vuetify.breakpoint.sm}"
                    >
                        <div class="grey-text mb-2">{{ $t("Группа организаций") }}</div>
                        <v-select
                            solo
                            append-icon=""
                            :label="$t('Выберите группу')"
                            class="input"
                            disabled
                            :value="current_request.group"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mb-4 :class="{'mt-4': $vuetify.breakpoint.smAndUp, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{ $t("Тип организации") }}</div>
                        <v-select
                            solo
                            append-icon=""
                            :label="$t('Выберите организацию')"
                            class="input"
                            disabled
                            :value="current_request.type"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 mb-4>
                        <div class="grey-text mb-2">{{ $t("Деятельность организации") }}</div>
                        <textareaBase :placeholder="$t('Введите текст')" rows="4" :value="current_request.activity"
                                      disabled
                        />
                    </v-flex>

                </v-layout>
                <v-card-actions>
                    <v-layout align-center wrap>
                        <buttonRed :class="{'flex xs12 mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="accept_new_org(current_request)">{{ $t("Одобрить") }}</buttonRed>
                        <buttonBdWhite :class="{'flex xs12 mt-3': $vuetify.breakpoint.xs}" @click.native="decline_new_org(current_request)">{{ $t("Отклонить") }}</buttonBdWhite>
                        <div class="grey-text" :class="{'mt-2': $vuetify.breakpoint.xs, 'ml-4': $vuetify.breakpoint.smAndUp}">{{ $t("* - поля, обязательные для заполнения") }}</div>
                    </v-layout>
                </v-card-actions>
            </template>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import inputBase from '@/components/ui/inputs/base/input';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import inputUpload from '@/components/ui/inputs/typed/input_upload.vue';
import textareaBase from '@/components/ui/inputs/base/textarea';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    buttonBdWhite,
    inputBase,
    checkbox,
    inputUpload,
    textareaBase,
  },
  computed: {
    ...mapGetters('users/employees', [
      'users_filters',
    ]),
    ...mapGetters('users/requests', [
      'request_id',
      'request_type',
      'current_request',
    ]),
  },
  methods: {
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
    ...mapActions('users/employees', [
      'accept_new_user',
      'decline_new_user',
      'update_users',
    ]),
    ...mapActions('users/organizations', [
      'accept_new_org',
      'decline_new_org',
    ]),
    async acceptNewUser() {
      await this.accept_new_user(this.current_request);
      await this.update_users();

      this.$root.$emit('users_req_updated');
    },
    async declineNewUser() {
      await this.decline_new_user(this.current_request);
      this.$root.$emit('users_req_updated');
    },
  },
};
</script>
